import React from 'react';
import { Dropdown, Icon, Checkbox, Loader } from 'semantic-ui-react';

import FeedList from './FeedList';
import useFeedData from './useFeedData';

import './style.less';

const Feeds = ({ history, lastUpdated, isArchived = false }) => {
    const {
        isDownloadingReport,
        saveRequestReport,
        handleCheckBoxChange,
        feedFilters,
        canViewRequets,
        paginating,
        feed,
        morePages,
        loadMore,
        isDisabledForPayment,
    } = useFeedData(lastUpdated, isArchived);
    return (
        <div>
            <div className="feed-title">
                <span
                    style={isDownloadingReport ? { pointerEvents: 'none', opacity: 0.4 } : {}}
                    onClick={saveRequestReport}
                    className="download-reports"
                >
                    <Icon name="download" /> {isDownloadingReport ? 'Preparing Report...' : 'Download reports'}
                </span>
                {isArchived ? 'ARCHIVED' : 'FEED'}
                <div className="filters-dropdown">
                    <Dropdown item simple text="Filters">
                        <Dropdown.Menu className="left">
                            <Dropdown.Item>
                                <Checkbox
                                    name="messages"
                                    label="Messages"
                                    onChange={handleCheckBoxChange}
                                    checked={feedFilters.messages}
                                    toggle
                                ></Checkbox>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Checkbox
                                    name="requests"
                                    label="Requests"
                                    onChange={handleCheckBoxChange}
                                    checked={feedFilters.requests}
                                    toggle
                                ></Checkbox>
                            </Dropdown.Item>
                            <Dropdown.Item>
                                <Checkbox
                                    name="activities"
                                    label="Activities"
                                    onChange={handleCheckBoxChange}
                                    checked={feedFilters.activities}
                                    toggle
                                ></Checkbox>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <div className="activity-list">
                {isDisabledForPayment ? (
                    <div className="no-invites">
                        This user(s) does not have an active Speak2 Family subscription. Please contact their Admin
                        to update their subscription to use Speak2 Family.
                    </div>
                ) : canViewRequets ? (
                    paginating ? (
                        <Loader inline="centered" active={paginating} />
                    ) : (
                        <FeedList history={history} requests={feed} morePages={morePages} loadMore={loadMore} />
                    )
                ) : (
                    <div className="no-invites">
                        You do not have permissions to view/act on the selected Residents' requests. Please ask the
                        selected residents' manager(s) to enable you to recieve requests.
                    </div>
                )}
                {}
            </div>
        </div>
    );
};

export default Feeds;
